export const HOROSCOPE_TRANSLATIONS: Record<string, any> = {
    'English': {
        // Daily/General
        dailySummary: "Daily Summary",
        mood: "Mood",
        energy: "Energy",
        luck: "Luck",
        health: "Health",
        wealth: "Wealth",
        career: "Career",
        relationship: "Relationship",
        recommendedActions: "Recommended Actions",
        thingsToAvoid: "Things to Avoid",
        remedies: "Remedies",
        luckyElements: "Lucky Elements",
        color: "Color",
        number: "Number",
        luckyTime: "Lucky Time",
        direction: "Direction",
        rahuKalam: "Rahu Kalam",
        planetaryInfluences: "Planetary Influences",
        personalLife: "Personal & Life",
        professionCareer: "Profession & Career",
        healthWellness: "Health & Wellness",
        emotionsSoul: "Emotions & Soul",
        travelGrowth: "Travel & Growth",
        fortuneLuck: "Fortune & Luck",
        ascendant: "Ascendant",
        sunSign: "Sun Sign",
        moonSign: "Moon Sign",
        english: "English",
        hindi: "Hindi",
        from: "From",
        to: "To",

        // Periods
        daily: "Daily",
        weekly: "Weekly",
        monthly: "Monthly",
        yearly: "Yearly",
        yesterday: "Yesterday",
        today: "Today",
        tomorrow: "Tomorrow",

        // Titles
        dailyHoroscope: "Daily Horoscope",
        weeklyHoroscope: "Weekly Horoscope",
        monthlyHoroscope: "Monthly Horoscope",
        yearlyHoroscope: "Yearly Horoscope",

        // Descriptions
        dailyDesc: "AI-powered predictions, Discover what the stars have in store for all zodiac signs today.",
        weeklyDesc: "AI-powered predictions, Your complete weekly cosmic forecast for love, career, and more.",
        monthlyDesc: "AI-powered predictions, Navigate the month ahead with personalized celestial guidance.",
        yearlyDesc: "AI-powered predictions, Uncover major themes and opportunities for your entire year.",
        yearlyForecastSuffix: "Yearly Forecast",

        // Elements
        Fire: "Fire",
        Water: "Water",
        Air: "Air",
        Earth: "Earth",

        // Display
        readingTheStars: "Reading the Stars...",
        connectingWithEnergies: "Connecting with celestial energies to reveal your forecast.",
        selectSignToReveal: "Select a sign to reveal the cosmos",
        cosmicForecast: "Cosmic Forecast",
        cosmicOverview: "Cosmic Overview",
        majorThemes: "Major Themes",
        focusOfMonth: "Focus of the Month",
        weeklyEnergy: "Weekly Energy",
        keyDates: "Key Dates",
        cosmicRemedies: "Cosmic Remedies",
        cosmicCaution: "Cosmic Caution",
        spiritualGuidance: "Spiritual Guidance",
        challengesOpportunities: "Challenges & Opportunities",
        detailedAnalysis: "Detailed Analysis",
        astrologicalAdvice: "Astrological Advice",

        // Signs
        Aries: "Aries",
        Taurus: "Taurus",
        Gemini: "Gemini",
        Cancer: "Cancer",
        Leo: "Leo",
        Virgo: "Virgo",
        Libra: "Libra",
        Scorpio: "Scorpio",
        Sagittarius: "Sagittarius",
        Capricorn: "Capricorn",
        Aquarius: "Aquarius",
        Pisces: "Pisces"
    },
    'Hindi': {
        // Daily/General
        dailySummary: "दैनिक राशिफल",
        mood: "मनोदशा",
        energy: "ऊर्जा",
        luck: "भाग्य",
        health: "स्वास्थ्य",
        wealth: "धन-संपत्ति",
        career: "करियर",
        relationship: "संबंध",
        recommendedActions: "सुझाव (क्या करें)",
        thingsToAvoid: "सावधानियां (क्या न करें)",
        remedies: "उपाय",
        luckyElements: "शुभ तत्व",
        color: "रंग",
        number: "अंक",
        luckyTime: "शुभ समय",
        direction: "दिशा",
        rahuKalam: "राहु काल",
        planetaryInfluences: "ग्रहीय प्रभाव",
        personalLife: "व्यक्तिगत जीवन",
        professionCareer: "करियर और व्यवसाय",
        healthWellness: "स्वास्थ्य और कल्याण",
        emotionsSoul: "भावनाएं और आत्मा",
        travelGrowth: "यात्रा और विकास",
        fortuneLuck: "किस्मत और भाग्य",
        ascendant: "लग्न",
        sunSign: "सूर्य राशि",
        moonSign: "चंद्र राशि",
        english: "अंग्रेजी",
        hindi: "हिंदी",
        from: "से",
        to: "तक",

        // Periods
        daily: "दैनिक",
        weekly: "साप्ताहिक",
        monthly: "मासिक",
        yearly: "वार्षिक",
        yesterday: "कल (बीता हुआ)",
        today: "आज",
        tomorrow: "कल (आने वाला)",

        // Titles
        dailyHoroscope: "दैनिक राशिफल",
        weeklyHoroscope: "साप्ताहिक राशिफल",
        monthlyHoroscope: "मासिक राशिफल",
        yearlyHoroscope: "वार्षिक राशिफल",

        // Descriptions
        dailyDesc: "एआई-संचालित भविष्यवाणियां, जानें कि आज सितारों ने सभी राशियों के लिए क्या रखा है।",
        weeklyDesc: "एआई-संचालित भविष्यवाणियां, प्रेम, करियर और बहुत कुछ के लिए आपका पूर्ण साप्ताहिक ब्रह्मांडीय पूर्वानुमान।",
        monthlyDesc: "एआई-संचालित भविष्यवाणियां, व्यक्तिगत आकाशीय मार्गदर्शन के साथ आने वाले महीने को नेविगेट करें।",
        yearlyDesc: "एआई-संचालित भविष्यवाणियां, अपने पूरे वर्ष के लिए प्रमुख थीम और अवसरों को उजागर करें।",
        yearlyForecastSuffix: "वार्षिक राशिफल",

        // Elements
        Fire: "अग्नि",
        Water: "जल",
        Air: "वायु",
        Earth: "पृथ्वी",

        // Display
        readingTheStars: "सितारों को पढ़ा जा रहा है...",
        connectingWithEnergies: "अपने पूर्वानुमान को प्रकट करने के लिए आकाशीय ऊर्जाओं से जुड़ रहा है।",
        selectSignToReveal: "ब्रह्मांड को प्रकट करने के लिए एक राशि चुनें",
        cosmicForecast: "ब्रह्मांडीय पूर्वानुमान",
        cosmicOverview: "ब्रह्मांडीय अवलोकन",
        majorThemes: "प्रमुख विषय",
        focusOfMonth: "महीने का केंद्र बिंदु",
        weeklyEnergy: "साप्ताहिक ऊर्जा",
        keyDates: "महत्वपूर्ण तिथियां",
        cosmicRemedies: "ब्रह्मांडीय उपाय",
        cosmicCaution: "ब्रह्मांडीय सावधानी",
        spiritualGuidance: "आध्यात्मिक मार्गदर्शन",
        challengesOpportunities: "चुनौतियां और अवसर",
        detailedAnalysis: "विस्तृत विश्लेषण",
        astrologicalAdvice: "ज्योतिषीय सलाह",

        // Signs
        Aries: "मेष",
        Taurus: "वृषभ",
        Gemini: "मिथुन",
        Cancer: "कर्क",
        Leo: "सिंह",
        Virgo: "कन्या",
        Libra: "तुला",
        Scorpio: "वृश्चिक",
        Sagittarius: "धनु",
        Capricorn: "मकर",
        Aquarius: "कुंभ",
        Pisces: "मीन"
    }
};
